import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy,
} from '@angular/core';



import { DefaultModalComponent } from './default-modal/default-modal.component';
import {first, takeWhile} from 'rxjs/operators';


@Component({
  template: '',
})
export class BaseModalComponent implements OnDestroy {

  @Input() ghostValue: string;

  @Output() ngDestroyEvent = new EventEmitter();
  @Output() onHidden: EventEmitter<any> = new EventEmitter();
  @Output() onShown: EventEmitter<any> = new EventEmitter();

  @ViewChild(DefaultModalComponent, {static: false})
  protected defaultModal: DefaultModalComponent | void;
  isModalShown: boolean = false;
  isActive: boolean = true;

  // public:
  public show() {
    if (this.defaultModal && this.defaultModal.defaultModal) {
      this.defaultModal.defaultModal.onShown
        .pipe(first(), takeWhile(() => this.isModalShown))
        .subscribe(() => {
          this.onShown.emit();
        });
      this.defaultModal.show();
    }
    this.isModalShown = true;
  }

  public hide() {
    if (this.defaultModal && this.defaultModal.defaultModal) {
      this.defaultModal.defaultModal.onHidden
        .pipe(first(), takeWhile(() => this.isActive))
        .subscribe(() => {
          this.onHidden.emit();
        });
      this.defaultModal.hide();
    }
    this.isModalShown = false;
  }

  ngOnDestroy() {
    this.isActive = false;
    this.isModalShown = false;
    this.ngDestroyEvent.emit();
  }
}
